import { RequestTransformer } from './api';

export const createRequestParamsTransformer = <Params extends object>({
  endpoints,
  swappableParams,
}: {
  endpoints: string[];
  swappableParams: Params;
}) => {
  return {
    name: 'params_transformer',
    transformApplies: ({ name }): boolean => endpoints.includes(name),
    transform: (params: object) => Object.assign(params, swappableParams),
  } as RequestTransformer;
};
